import { handleRequestErrors } from "../services/handleRequestError";
import { rankQuickAnswersResponse } from "../util/quickAnswerSearchRanking";

const getShortcutDisplayLimit = (params) => params.displayLimit;

const buildShortcutEndpointParams = (params) => {
  const { displayLimit, ...endpointParams } = params;
  return endpointParams;
};

const dispatchRankedShortcutAnswers = (dispatch, actionType, data, params) => {
  dispatch({
    type: actionType,
    data: rankQuickAnswersResponse(data, params.search, getShortcutDisplayLimit(params))
  });
};

export const getWhatsAppFastAnswersForShortcut = (params = {}) => {
  const encodedParams = new URLSearchParams(buildShortcutEndpointParams(params)).toString();
  const endpoint = `/api/v1/fast_answers_for_whatsapp?${encodedParams}`;

  return (dispatch) => {
    fetch(endpoint, {
      method: "GET",
      credentials: "same-origin",
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-Type": "application/json"
      }
    })
      .then((res) => res.json())
      .then(
        (data) => dispatchRankedShortcutAnswers(
          dispatch,
          "SET_SHORTCUT_WHATSAPP_FAST_ANSWERS",
          data,
          params
        ),
        (err) => dispatch({ type: "LOAD_DATA_FAILURE", err })
      ).catch(() => {
      });
  };
};

export const getMessengerFastAnswersForShortcut = (params = {}) => {
  const encodedParams = new URLSearchParams(buildShortcutEndpointParams(params)).toString();
  const endpoint = `/api/v1/fast_answers_for_messenger?${encodedParams}`;

  return (dispatch) => {
    fetch(endpoint, {
      method: "GET",
      credentials: "same-origin",
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-Type": "application/json"
      }
    })
      .then((res) => res.json())
      .then(
        (data) => dispatchRankedShortcutAnswers(
          dispatch,
          "SET_SHORTCUT_MESSENGER_FAST_ANSWERS",
          data,
          params
        ),
        (err) => dispatch({ type: "LOAD_DATA_FAILURE", err })
      ).catch(() => {
      });
  };
};

export const getInstagramFastAnswersForShortcut = (params = {}) => {
  const encodedParams = new URLSearchParams(buildShortcutEndpointParams(params)).toString();
  const endpoint = `/api/v1/fast_answers_for_instagram?${encodedParams}`;

  return (dispatch) => {
    fetch(endpoint, {
      method: "GET",
      credentials: "same-origin",
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-Type": "application/json"
      }
    })
      .then((res) => res.json())
      .then(
        (data) => dispatchRankedShortcutAnswers(
          dispatch,
          "SET_SHORTCUT_INSTAGRAM_FAST_ANSWERS",
          data,
          params
        ),
        (err) => dispatch({ type: "LOAD_DATA_FAILURE", err })
      ).catch(() => {
      });
  };
};

export const getCommentsFastAnswersForShortcut = (params = {}, platform) => {
  const encodedParams = new URLSearchParams(buildShortcutEndpointParams(params)).toString();
  let endpoint;
  if (platform === 'facebook_comments') {
    endpoint = `/api/v1/fast_answers_for_fb_comments?${encodedParams}`;
  } else {
    endpoint = `/api/v1/fast_answers_for_ig_comments?${encodedParams}`;
  }

  return (dispatch) => {
    fetch(endpoint, {
      method: "GET",
      credentials: "same-origin",
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-Type": "application/json"
      }
    })
      .then((res) => handleRequestErrors(res, false))
      .then((data) => {
        dispatchRankedShortcutAnswers(
          dispatch,
          "SET_SHORTCUT_COMMENTS_FAST_ANSWERS",
          data,
          params
        );
      }).catch((error) => {
        dispatch({ type: "LOAD_DATA_FAILURE", error });
      });
  };
};

export const getFastAnswersForComments = (params = {}, platform) => {
  let endpoint;

  if (platform === 'facebook_comments') {
    endpoint = `/api/v1/fast_answers_for_fb_comments`;
  } else {
    endpoint = `/api/v1/fast_answers_for_ig_comments`;
  }

  const encodedParams = new URLSearchParams(params).toString();
  endpoint = `${endpoint}?${encodedParams}`;

  return (dispatch) => {
    fetch(endpoint, {
      method: "GET",
      credentials: "same-origin",
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-Type": "application/json"
      }
    })
      .then((res) => handleRequestErrors(res, false))
      .then((data) => {
        dispatch({ type: "SET_COMMENTS_FAST_ANSWERS", data });
      }).catch((error) => {
        dispatch({ type: "LOAD_DATA_FAILURE", error });
      });
  };
};

export const getFastAnswers = (page = 1, params) => {
  let endpoint = `/api/v1/templates?page=${page}&`;
  if (params) {
    const queryString = new URLSearchParams(params).toString();
    endpoint += queryString;
  }

  return (dispatch) => {
    fetch(endpoint, {
      method: "GET",
      credentials: "same-origin",
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-Type": "application/json"
      }
    })
      .then((res) => handleRequestErrors(res, false))
      .then((data) => {
        dispatch({ type: "SET_COMMENTS_FAST_ANSWERS", data });
      }).catch((error) => {
        dispatch({ type: "LOAD_DATA_FAILURE", error });
      });
  };
};

export const getTikTokFastAnswers = (params = {}, platform) => {
  let endpoint;

  if (platform === 'tik_tok_messages') {
    endpoint = `/api/v1/fast_answers_for_tik_tok_messages`;
  } else {
    endpoint = `/api/v1/fast_answers_for_tik_tok_comments`;
  }

  const encodedParams = new URLSearchParams(params).toString();
  endpoint = `${endpoint}?${encodedParams}`;

  return (dispatch) => {
    fetch(endpoint, {
      method: "GET",
      credentials: "same-origin",
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-Type": "application/json"
      }
    })
      .then((res) => handleRequestErrors(res, false))
      .then((data) => {
        dispatch({ type: "SET_TIKTOK_FAST_ANSWERS", data });
      }).catch((error) => {
        dispatch({ type: "LOAD_DATA_FAILURE", error });
      });
  };
};

export const getTikTokFastAnswersForShortcut = (params = {}, platform) => {
  const encodedParams = new URLSearchParams(buildShortcutEndpointParams(params)).toString();
  let endpoint;
  if (platform === 'tik_tok_messages') {
    endpoint = `/api/v1/fast_answers_for_tik_tok_messages?${encodedParams}`;
  } else {
    endpoint = `/api/v1/fast_answers_for_tik_tok_comments?${encodedParams}`;
  }

  return (dispatch) => {
    fetch(endpoint, {
      method: "GET",
      credentials: "same-origin",
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-Type": "application/json"
      }
    })
      .then((res) => handleRequestErrors(res, false))
      .then((data) => {
        dispatchRankedShortcutAnswers(
          dispatch,
          "SET_SHORTCUT_TIKTOK_FAST_ANSWERS",
          data,
          params
        );
      }).catch((error) => {
        dispatch({ type: "LOAD_DATA_FAILURE", error });
      });
  };
};

export const createFastAnswer = (body, csrfToken) => {
  const endpoint = `/api/v1/templates`;

  return (dispatch) => {
    dispatch({ type: 'START_SAVING_FAST_ANSWER_REQUEST' });
    fetch(endpoint, {
      method: "POST",
      credentials: "same-origin",
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-Type": "application/json",
        'X-CSRF-Token': csrfToken
      },
      body: JSON.stringify(body)
    })
      .then(handleRequestErrors)
      .then((data) => {
        dispatch({ type: 'END_SAVING_FAST_ANSWER_REQUEST' });
        dispatch({ type: 'CREATE_FAST_ANSWER', data });
      })
      .catch(() => {
        dispatch({ type: 'END_SAVING_STAFF_REQUEST' });
      });
  };
};
